<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-select style="width: 100%;" filterable clearable  v-model="searchInfo.id" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="searchSysConfig" icon="el-icon-search">搜索</el-button>
					<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<el-button type="primary" icon="el-icon-plus" @click="addStall">新增</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="sysReportList"  style="width: 100%"  max-height="700">
			    <el-table-column fixed="left" prop="year" label="年份"  width="80" align="center"></el-table-column>
				<el-table-column fixed="left" prop="month" label="月份"  width="80" align="center"></el-table-column>
				<el-table-column prop="orgnam" label="所属校区"  align="center"></el-table-column>
				<el-table-column prop="totalpower" label="总耗电(kWh)" align="center"></el-table-column>
				<el-table-column prop="airpower" label="空调耗电(kWh)" align="center"></el-table-column>
				<el-table-column prop="lightpower" label="照明耗电(kWh)" align="center"></el-table-column>
				<el-table-column prop="otherpower" label="其他耗电(kWh)" align="center"></el-table-column>
				<el-table-column prop="path" label="报表路径"  align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goSysReportDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a @click="deleteDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="sysReportTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<ReportDetail @needRefrash="needRefrash" :add="isadd" :orgList="orgList" :selectedhis="selectset"></ReportDetail>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryAllOrg, queryHisPowerByPage, deleteHisPower } from '/static/apiUrl.js'
	import ReportDetail from './reportdetail'
	export default {
		name : 'ReportList',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '报表详情',
				selectset: null,	
				searchInfo:{
					name: '',
					id : '',
				},
				orgList : [],
				param : {
					page : 1,
					pagenum : 10,
				},
				sysReportTotal : 0,
				sysReportList : [],
			}
		},
		mounted() {
			this.initData()
			this.queryHisReports()
		},
		components: {
			ReportDetail,
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryHisReports()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryHisReports()
			},
			initData() {
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			searchSysConfig(){
				this.param.page = 1
				this.sysReportList = []
				this.queryHisReports()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.id = ''
				this.param.page = 1
				this.queryHisReports()
			},
			queryHisReports(){
				this.sysReportList = []
				queryHisPowerByPage({
					oid : this.searchInfo.id,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						this.sysReportTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysReportList.push(set)
						})
					}
				})
			},
			goSysReportDetail(idx,row){
				this.detailTitle = '报表详情'
				this.isadd = false
				console.log(idx,row)
				this.selectset = JSON.parse(JSON.stringify(this.sysReportList[idx]))
				this.detailShow = true
			},
			deleteDetail(idx,row){
				this.$confirm('此操作将删除报表数据 '+this.sysReportList[idx].orgnam +this.sysReportList[idx].year +'年'+ 
					this.sysReportList[idx].month +'月报表, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteHisPower({
						id : this.sysReportList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryHisReports()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addStall(){
				this.detailTitle = "新增报表"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			needRefrash(val,isshow){
				//console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				//console.log('ddd')
				if(this.editok){
					this.queryHisReports()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>